<script>
  import { onMount } from 'svelte';
  import { trackEvent } from '@button/ui/utils';
  import { sendDebugEvent } from './debug.js';
  import { LOCAL_STORAGE_KEY_LANGUAGE } from './constants';

  let selectedLanguage = '';

  onMount(() => {
    // Retrieve the selected language from localStorage
    selectedLanguage = localStorage.getItem(LOCAL_STORAGE_KEY_LANGUAGE) || '';
  });

  async function handleChange(event) {
    trackEvent('language-selector', {
      selected: event.target.value,
    });

    try {
      // this request was getting canceled when
      // when the reload happens. if it fails, do nothing.
      await sendDebugEvent('locale-changed', {
        locale: event.target.value,
      });
    } catch {}

    selectedLanguage = event.target.value;
    localStorage.setItem(LOCAL_STORAGE_KEY_LANGUAGE, selectedLanguage);

    // reload the page to apply the new language
    window.location.reload();
  }
</script>

<select
  on:change={handleChange}
  class="w-full appearance-none rounded-lg border-none bg-transparent px-4 py-2 text-base font-normal text-gray-500"
  id="languageDropdown"
  value={selectedLanguage}
>
  <option value="" disabled selected>Select Language</option>
  <option value="en" aria-label="English (US)">🇺🇸 English (US)</option>
  <option value="ja" aria-label="日本語 (JA)">🇯🇵 日本語 (JA)</option>
  <option value="es" aria-label="Espanol (ES)">🇪🇸 Espanol (ES)</option>
  <option value="it" aria-label="Italiano (IT)">🇮🇹 Italiano (IT)</option>
  <option value="pt" aria-label="Português (BR)">🇧🇷 Português (BR)</option>
  <option value="de" aria-label="Deutsche (DE)">🇩🇪 Deutsche (DE)</option>
</select>
